import { useContext } from "react";
import PeriodicTable from "../element_table";
import { calcFormulaWeight, calcAtomicCount } from "../calcfw";
import { ChemicalFormulaContext } from "../contexts/formulaprovider";
import { STable, SCaption, SThead, STbody, STh, STdC, STdR, SButtonCopyToClipboard } from "./styled";

export const ElementTable = () => {
  const { elements } = useContext(ChemicalFormulaContext);
  const pt = new PeriodicTable();

  let data = [];
  let keys = [];

  let fw = 0.0;
  let atomCount = 0;

  if (elements !== null) {
    fw = calcFormulaWeight(elements);
    atomCount = calcAtomicCount(elements);
  }

  for (let symbol of elements.keys()) {
    keys.push(symbol);
  }

  for (let symbol of keys.sort((a, b) => pt.symbolToNo(a) - pt.symbolToNo(b))) {
    const z = pt.symbolToNo(symbol);
    let at = atomCount === 0 ? undefined : elements.get(symbol) / atomCount;
    let wt = fw === 0 ? undefined : (elements.get(symbol) * pt.getWeight(z)) / fw;
    data.push({
      z,
      symbol,
      atom: elements.get(symbol),
      weight: pt.getWeight(z),
      at: typeof at !== "undefined" ? parseInt(at * 10000 + 0.5) / 100 : "---",
      wt: typeof wt !== "undefined" ? parseInt(wt * 10000 + 0.5) / 100 : "---",
    });
  }

  const onClickToClipboard = () => {
    copyResults(data, fw);
  };

  return (
    <>
      <STable>
        <SCaption>元素情報</SCaption>
        <SThead>
          <tr>
            <STh className="table-header">原子番号</STh>
            <STh className="table-header">元素記号</STh>
            <STh className="table-header">原子数</STh>
            <STh className="table-header">原子量</STh>
            <STh className="table-header">原子数比(%)</STh>
            <STh className="table-header">質量比(%)</STh>
          </tr>
        </SThead>
        <STbody>
          {data.map((atom) => {
            return (
              <tr key={atom.z}>
                <STdC className="table-data data-label">{atom.z}</STdC>
                <STdC className="table-data data-label">{atom.symbol}</STdC>
                <STdR className="table-data data-label">{atom.atom}</STdR>
                <STdR className="table-data data-value">{atom.weight}</STdR>
                <STdR className="table-data data-value">{atom.at}</STdR>
                <STdR className="table-data data-value">{atom.wt}</STdR>
              </tr>
            );
          })}
        </STbody>
      </STable>
      <SButtonCopyToClipboard onClick={onClickToClipboard} disabled={data.length === 0}>
        クリップボードにコピー
      </SButtonCopyToClipboard>
    </>
  );
};

const copyResults = (data, fw) => {
  let text = `式量\t${fw}\n`;
  text += `原子番号\t元素記号\t原子数\t原子量\t原子数比(%)\t質量比(%)\n`;

  for (let i = 0; i < data.length; i++) {
    text += `${data[i].z}\t${data[i].symbol}\t${data[i].atom}\t${data[i].weight}\t`;
    text += `${data[i].at}\t${data[i].wt}\n`;
  }

  navigator.clipboard.writeText(text);
};
